// extracted by mini-css-extract-plugin
export default {"bodyWrapper":"PrivacyModal_bodyWrapper__Jd9GC","headerWrapper":"PrivacyModal_headerWrapper__0248c"};